import Vue from 'vue';
import Router from 'vue-router';
import routes from './routes';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes,
  scrollBehavior() {
    const container = document.getElementsByClassName('main-content')[0];
    container.scrollTop = 0;
  },
});
